import {getIdToken} from "../../misc/miscUtils.ts";
import {URL_BASE} from "../../../Globals.ts";

export const writeSharedChat = async (user: any, uuid: string, chatName: string, messages: any[], messagesSequence: number[]) => {
    try {
        const token = await getIdToken(user);

        const url = `${URL_BASE}/api/writeSharedChat`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                uuid: uuid,
                chatName: chatName,
                messages: messages,
                messagesSequence: messagesSequence
            })
        });

        if (response.ok) {
            return true;
        } else {
            console.error(`HTTP error: ${response.status} ${response.statusText}`);
            return false;
        }
    } catch (error) {
        console.error(`Error in writeSharedChat: ${error}`);
        return false;
    }
}
